"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.testConfig = void 0;
exports.initPatientChat = initPatientChat;
const chat_1 = require("../chat");
const OrganizationUser_1 = __importDefault(require("../organizationuser/OrganizationUser"));
const socket_1 = require("../socket");
const store_1 = require("../store");
const user_1 = require("../user");
const fakeAdapters_1 = require("./fakeAdapters");
const FakeAdapterFactory_1 = require("./fakeAdapters/FakeAdapterFactory");
const utils_1 = require("../utils");
const FakeInternetStatusManager_1 = require("./FakeInternetStatusManager");
exports.testConfig = {
    baseUrl: "https://undefined",
    platformType: "WEB",
    applicationVersion: "2.34.4",
    apiVersion: "1",
    userPoolId: "us-east-1_nhVG0Syz4",
    region: "us-east-1",
    acl: "private",
    slowMessageThresholdMs: 6000,
};
function initPatientChat(organizationData, chatId, chatData) {
    return __awaiter(this, void 0, void 0, function* () {
        const fakeSocketAdapter = new fakeAdapters_1.FakeSocketAdapter();
        const fakeChatAdapter = new fakeAdapters_1.FakeChatAdapter();
        fakeChatAdapter.getGroupInfo = jest.fn().mockImplementation(() => {
            return (0, utils_1.CompletedResult)(Object.assign({}, chatData));
        });
        const fakeHttpAdapter = new fakeAdapters_1.FakeHttpAdapter().withChatAdapter(fakeChatAdapter);
        const fakeAuthAdapter = new fakeAdapters_1.FakeAuthAdapter();
        const fakeAdapterFactory = new FakeAdapterFactory_1.FakeAdapterFactory()
            .withHttpAdapter(fakeHttpAdapter)
            .withSocketAdapter(fakeSocketAdapter);
        const fakeInternetStatusManager = new FakeInternetStatusManager_1.FakeInternetStatusManager();
        const organizationUser = new OrganizationUser_1.default(organizationData, exports.testConfig, fakeAdapterFactory, fakeAuthAdapter, fakeInternetStatusManager);
        organizationUser.networkManager.init();
        yield organizationUser.open();
        const userDirectory = new user_1.UserDirectory(organizationUser, fakeHttpAdapter);
        yield userDirectory.fetchUserDirectory();
        const socketListner = new socket_1.SocketListener(userDirectory, organizationData);
        fakeSocketAdapter.withDomainListener(socketListner);
        const hhnStorage = new store_1.HhnStorage(organizationUser.getOrganization().organizationId, organizationUser.networkManager);
        const patientChats = new chat_1.PatientChats(fakeHttpAdapter, organizationUser, fakeSocketAdapter, exports.testConfig, userDirectory, hhnStorage);
        yield patientChats.getFreshChat(chatId);
        return {
            chat: patientChats.getChat(chatId),
            socketAdapter: fakeSocketAdapter,
            userDirectory,
        };
    });
}
